export default {
  // 时间格式处理
  format: function (time, format) {
    var t = new Date(time)
    // return t
    var tf = function (i) { return (i < 10 ? '0' : '') + i }
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear())
        case 'MM':
          return tf(t.getMonth() + 1)
        case 'mm':
          return tf(t.getMinutes())
        case 'dd':
          return tf(t.getDate())
        case 'HH':
          return tf(t.getHours())
        case 'ss':
          return tf(t.getSeconds())
      }
    })
  },
  // 手机号码验证
  testPhone: function (phone) {
    var regex = /^[1][3,4,5,7,8,6,9][0-9]{9}$/
    if (regex.test(phone)) {
      return true
    } else {
      return false
    }
  },
  // 身份证号码验证
  testID: function (ID) {
    var regex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (regex.test(ID)) {
      return true
    } else {
      return false
    }
  },
  // 整数
  integerReg: function (num) {
    var regex = /^[0-9]*[1-9][0-9]*$/
    if (regex.test(num)) {
      return true
    } else {
      return false
    }
  },
  // 两位小数
  floatReg: function (num) {
    var regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
    if (regex.test(num)) {
      return true
    } else {
      return false
    }
  },
  // 字符串处理
  strCut: function (str, num) {
    var strObj = ''
    if (str === '' || str === undefined || str == null) {
      strObj = ''
    } else if (str.length < num) {
      strObj = str
    } else {
      strObj = str.substring(0, 80) + '......'
    };
    return strObj
  },
  // 判断是否为数字并无中文
  isNum: function (num) {
    var regex1 = /^[0-9]+.?[0-9]*$/
    var regex2 = /[\u4e00-\u9fa5]/g
    if (regex1.test(num) && !regex2.test(num)) {
      return true
    } else {
      return false
    }
  },
  // 数值转换
  toStr: function (value, arr) {
    var str = ''
    arr.forEach(function (item) {
      if (item.value == value) {
        str = item.name
      }
    })
    return str
  },
  // 数值转换（1）
  toStr1: function (value, arr) {
    var str = '-'
    arr.forEach(function (item) {
      if (item.value == value) {
        str = item.name
      }
    })
    return str
  },
}



// WEBPACK FOOTER //
// ./src/common/unit.js